const ROVO_CREATE_VIEW_SPACE_SOURCE = 'rovo-create-view-space';

/**
 * Drops `source=rovo-create-view-space` from the current URL.
 *
 * The Rovo plan card treats that query param as "user is viewing this space".
 * Opening the create-space modal does not navigate, so the param would otherwise
 * linger and the next created space would show "Viewing now" instead of "View space".
 */
export const removeRovoCreateViewSpaceSource = (): void => {
	if (typeof globalThis.window === 'undefined') {
		return;
	}

	const url = new URL(globalThis.window.location.href);
	if (url.searchParams.get('source') !== ROVO_CREATE_VIEW_SPACE_SOURCE) {
		return;
	}

	url.searchParams.delete('source');
	globalThis.window.history.replaceState(
		globalThis.window.history.state,
		'',
		`${url.pathname}${url.search}${url.hash}`,
	);
};
